import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/exame-imagem`

    const headers = { responseType: "arraybuffer" }

    return {
        exportProducao(queryParms) {

            return repository.get(`${baseUrl}/export-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        exportExameStatus(params) {

            return repository.post(`${baseUrl}/export-exame-status`, params, headers)
        },
        exportCotaProfissional(queryParms) {

            return repository.get(`${baseUrl}/export-cota-profissional?${urlUtil.serialize(queryParms)}`, headers)
        },
        exportFinanceiroExame(queryParms) {

            return repository.get(`${baseUrl}/export-financeiro-exame?${urlUtil.serialize(queryParms)}`, headers)
        }
    }
}